import { FormFields } from './makeFormFields';

export default function makePayload(formFields: FormFields) {
  return {
    ...formFields,
  };
}
